import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';

import { useFragment } from '@libs/trip-planner-interfaces';
import type {
  FragmentType,
  GraphQL,
  Money,
} from '@libs/trip-planner-interfaces';

import { MoneyFragment } from '../../queries';
import { assertSmartSearchValue } from '../../utils';

export function toMoney(
  moneyFragmentQL: FragmentType<
    DocumentTypeDecoration<GraphQL.MoneyFragment, unknown>
  >
): Money {
  const moneyFragment = useFragment(MoneyFragment, moneyFragmentQL);

  assertSmartSearchValue(moneyFragment.amount);
  assertSmartSearchValue(moneyFragment.currency);
  assertSmartSearchValue(moneyFragment.currencySymbol);

  return {
    amount: moneyFragment.amount,
    currency: moneyFragment.currency,
    currencySymbol: moneyFragment.currencySymbol,
  };
}
